import { Component, input, computed } from '@angular/core';

@Component({
  selector: 'app-item-selected-summary',
  template: `
      <div class="flex align-items-center justify-content-between surface-ground border-400 border-1 py-3 pl-3">
        <span class="font-medium">{{text()}}</span>
      </div>
  `,
  styles: ``
})
export class ItemSelectedSummaryComponent {

    numSelected = input<number|undefined|null>();
    type = input<'selected'|'searched'>('selected');

    public text = computed<string>( () => {
        let result = '';

              
        if( this.numSelected() ){
          result = 'Documenti ';
          if ( this.type() == 'selected') {
            result += 'selezionati ';
          }
          if ( this.type() == 'searched') {
            result += 'trovati ';
          }

          result +=`${this.numSelected() ? this.numSelected() : 0 }`;
        }

        if( !this.numSelected() ){
          result = 'Nessun documento ';
          if ( this.type() == 'selected') {
            result += 'selezionato';
          }
          if ( this.type() == 'searched') {
            result += 'trovato';
          }
        }

        return result;
    });
}
